import type { HMSPeer } from "@100mslive/react-sdk";
import { PARTICIPANT_ROLES } from "@circle-react/helpers/liveStreamRoomHelpers";
import type { ParticipantRole } from "@circle-react/types/Live/Participant";
import type { Peer } from "@circle-react/types/Live/Peer";

export const convertHMSPeerToPeer = (hmsPeer: HMSPeer): Peer => ({
  ...hmsPeer,
  roleName: (hmsPeer.roleName ||
    PARTICIPANT_ROLES.HLS_SPECTATOR) as ParticipantRole,
  isSpeaking: false,
});
